/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { GaussianSurfaceMeshParams, StructureGaussianSurfaceVisual, GaussianSurfaceVisual } from '../visual/gaussian-surface-mesh';
import { UnitsRepresentation } from '../units-representation';
import { GaussianWireframeVisual, GaussianWireframeParams } from '../visual/gaussian-surface-wireframe';
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { StructureRepresentationProvider, StructureRepresentationStateBuilder, ComplexRepresentation } from '../representation';
import { Representation } from '../../../mol-repr/representation';
var GaussianSurfaceVisuals = {
  'gaussian-surface-mesh': function (ctx, getParams) {
    return UnitsRepresentation('Gaussian surface mesh', ctx, getParams, GaussianSurfaceVisual);
  },
  'structure-gaussian-surface-mesh': function (ctx, getParams) {
    return ComplexRepresentation('Structure-Gaussian surface mesh', ctx, getParams, StructureGaussianSurfaceVisual);
  },
  'gaussian-surface-wireframe': function (ctx, getParams) {
    return UnitsRepresentation('Gaussian surface wireframe', ctx, getParams, GaussianWireframeVisual);
  }
};
export var GaussianSurfaceParams = __assign(__assign(__assign({}, GaussianSurfaceMeshParams), GaussianWireframeParams), {
  visuals: PD.MultiSelect(['gaussian-surface-mesh'], PD.objectToOptions(GaussianSurfaceVisuals))
});
export function getGaussianSurfaceParams(ctx, structure) {
  return PD.clone(GaussianSurfaceParams);
}
export function GaussianSurfaceRepresentation(ctx, getParams) {
  return Representation.createMulti('Gaussian Surface', ctx, getParams, StructureRepresentationStateBuilder, GaussianSurfaceVisuals);
}
export var GaussianSurfaceRepresentationProvider = StructureRepresentationProvider({
  name: 'gaussian-surface',
  label: 'Gaussian Surface',
  description: 'Displays a gaussian molecular surface.',
  factory: GaussianSurfaceRepresentation,
  getParams: getGaussianSurfaceParams,
  defaultValues: PD.getDefaultValues(GaussianSurfaceParams),
  defaultColorTheme: {
    name: 'chain-id'
  },
  defaultSizeTheme: {
    name: 'uniform'
  },
  isApplicable: function (structure) {
    return structure.elementCount > 0;
  }
});